module.exports = __webpack_public_path__ + "static/media/Moldflow Communicator.4d5e3af3.png";